import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/storage.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private authService: AuthService,
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let user = this.storageService.getUserData();
    let currentUser = user ? JSON.parse(user) : null;
    let lang = this.storageService.getSeletedLanguage();
    let langCode = lang ? JSON.parse(lang).code : 'EN-GB';
    if (currentUser) {
      request = this.authService.addTokenHeader(request, currentUser.token, langCode);
    }
    return next.handle(request);
  }
}
